import { Tabs, Tab, Box, Typography } from "@mui/material";

export const TabCp = ({ value, setValue }) => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "flex-start",
        gap: { xs: 1, sm: 2 },
        mt: 2,
        px: { xs: 1, sm: 2 },
      }}
    >
      <Box
        onClick={() => setValue("Service")}
        sx={{
          px: 6,
          py: { xs: "12px", sm: 1 },
          borderRadius: "20px",
          backgroundColor: value === "Service" ? "#4A4ABD" : "transparent",
          cursor: "pointer",
        }}
      >
        <Typography
          sx={{
            fontFamily: "'Montserrat', sans-serif",
            color: value === "Service" ? "#fff" : "#01008B",
            fontWeight: value === "Service" ? 600 : 500,
            fontSize: { xs: "12px", sm: "16px" },

            textAlign: "center",
          }}
        >
          Service
        </Typography>
      </Box>
      <Box
        onClick={() => setValue("Product")}
        sx={{
          px: 6,
          py: { xs: "12px", sm: 1 },
          borderRadius: "20px",
          backgroundColor: value === "Product" ? "#4A4ABD" : "transparent",
          cursor: "pointer",
        }}
      >
        <Typography
          sx={{
            fontFamily: "'Montserrat', sans-serif",
            color: value === "Product" ? "#fff" : "#01008B",
            fontWeight: value === "Product" ? 600 : 500,
            fontSize: { xs: "12px", sm: "16px" },
            textAlign: "center",
          }}
        >
          Product
        </Typography>
      </Box>
    </Box>
  );
};
